import React, { useState } from 'react';
import cx from 'classnames';
import { BusinessHours } from '../../../../modules/AsideSearchBarAndContent/types';
import { Divider } from '../../../Divider';
import { Icon } from '../../../Icons';
import { AddressProps } from '../../common/types';
import styles from '../style.module.css';
import { ShopAddress } from './ShopAddress';
import { ShopOpeningHours } from './ShopOpeningHours';

interface Props {
  address: AddressProps;
  businessHours: BusinessHours[];
  showH2?: boolean;
  dataValue?: string;
}

export const ShopAddressAndHourMobile = ({ address, dataValue, businessHours }: Props) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggleAddressAndHour = () => {
    setExpanded(!expanded);
  };

  const renderAddressAndHourExpanded = () => {
    if (!expanded) {
      return null;
    }

    return (
      <>
        <ShopAddress address={address} showH2 dataValue={dataValue} />
        {address.cepAddress && <Divider className={cx('mv24', styles.clear)} />}
        {/* TODO: adicionar novamente quando corrigir horario de funcionamento */}
        {/* <ShopOpeningHours businessHours={businessHours} /> */}
        <Divider className={cx('mv24', styles.clear)} />
      </>
    );
  };

  const renderAddressAndHourCollapsed = () => {
    const iconName = expanded ? 'SvgIconArrowUp' : 'SvgIconArrowDown';

    return (
      <span
        className="f14 trueno red fw6 flex items-center justify-center gtmShowAddress"
        onClick={handleToggleAddressAndHour}
        data-value={dataValue}
      >
        ENDEREÇO E HORÁRIOS
        <Icon name={iconName} className={cx('ml8', styles.icon)} dataValue={dataValue} />
      </span>
    );
  };

  return (
    <>
      {renderAddressAndHourExpanded()}
      {renderAddressAndHourCollapsed()}
    </>
  );
};
